module.exports = __webpack_public_path__ + "img/bee-logo-color.7152a3a2.png";